import React from 'react'
import { FundItem } from '../../../../models/Fund'
import { Box } from '@mui/material';
import OverviewGeneralInfo from './OverviewGeneralInfo';
import OverviewSectorDistribution from './OverviewSectorDistribution';
import OverviewStageDistribution from './OverviewStageDistribution';
import OverviewFeeOther from './OverviewFeeOther';

export interface IOverviewTabContentProps{
    fund: FundItem;
    createPortfolio?: boolean;
}

const OverviewTabContent: React.FC<IOverviewTabContentProps> = ({ fund, createPortfolio }) => {
  return <Box display={"flex"} width={"100%"} gap={"26px"}>
    <OverviewGeneralInfo fund={fund} createPortfolio={createPortfolio} />
    <OverviewSectorDistribution fund={fund} /> 
    <OverviewStageDistribution fund={fund} /> 
    <OverviewFeeOther fund={fund} /> 
  </Box>
}

export default OverviewTabContent